import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from '../styles.module.css';

type AnimationPhrasesProps = {
  phrases: string[];
};

export const AnimationPhrases = ({ phrases }: AnimationPhrasesProps) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIndex((prevIndex) => (prevIndex + 1) % phrases.length);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, [index]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!phrases[index]) return null;

  return (
    <span key={index} className={classNames(styles.phrase, styles.fade)}>
      {phrases[index]}
    </span>
  );
};
